import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../../helpers/dataConverts";
import { AffiliatesApiData } from "../interfaces";
import { LeadStatusCell } from "../table/StatusWithDot";
import { formatDateDMY } from "../utils";
import { RemanDaysCell } from "../table/RemainDaysCell";

export const AffiliatesLeadCard = ({
  leadData,
  index,
}: {
  leadData: AffiliatesApiData;
  index: number;
}) => {
  const { t, i18n } = useTranslation(["profile"]);
  const currentLanguage = i18n.language;

  return (
    <div className="lead-card-wrapper">
      <div className="lead-card-number">
        {t("lead")} #{index + 1}
      </div>

      <div className="lead-card-items-container">
        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">{t("leadName")}</div>
          <div className="lead-card-item-item-value">
            {leadData.invitedUser?.fullName
              ? leadData.invitedUser.fullName
              : "-"}
          </div>
        </div>

        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">
            {t("registrationDate")}
          </div>
          <div className="lead-card-item-item-value">
            {formatDateDMY(leadData.registrationDate, currentLanguage)}
          </div>
        </div>
        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">{t("endDate")}</div>
          <div className="lead-card-item-item-value">
            {RemanDaysCell(leadData.endDate)}
          </div>
        </div>

        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">{t("leadStatus")}</div>
          <div className="lead-card-item-item-value">
            {LeadStatusCell(leadData.leadStatus)}
          </div>
        </div>
        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">{t("earned")}</div>
          <div className="lead-card-item-item-value">
            {formatPrice(leadData.earned)}
          </div>
        </div>

        <div className="lead-card-item-container">
          <div className="lead-card-item-item-name">{t("pending")}</div>
          <div className="lead-card-item-item-value">
            {formatPrice(leadData.pending)}
          </div>
        </div>
      </div>
    </div>
  );
};
